import { Typography } from "@/design-system/Atoms";
import { useInViewOnce } from "@/hooks/useInViewOnce";

interface HowItWorksStepCardProps {
  icon: string;
  title: string;
  description: string;
  className: string;
}
const HowItWorksStepCard = ({
  icon,
  title,
  description,
  className,
}: HowItWorksStepCardProps) => {
  const { ref, isVisible } = useInViewOnce<HTMLDivElement>();
  return (

    <div
      className={`flex items-start p-10 rounded-[20px] mb-[1em] ${className}`}
    >

      {icon && (
        <div className="">
          <img src={icon} alt={`${title} icon`} className="me-10 max-w-fit" />
        </div>
      )}

      <div>
        {title && (
          <Typography variant="headingH3" as="h3" ref={ref} className={`mb-5 transition-opacity duration-700 ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="cardDescription" as="p" className="mb-4">
            {description}
          </Typography>
        )}
      </div>

    </div>
  );
};

export default HowItWorksStepCard;
